import { HttpClient } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "../../auth/AuthService";
import { AppService } from "../../services/app.service";
import { Location } from "@angular/common";
import { WebService } from "../../services/WebService";
import { BaseComponent } from "./base.component";
import { webService } from "../../webServices/api";
import { Constants } from "../../helpers/Constants";

declare var $: any;
declare var window: any;
declare var google: any;

export abstract class GoogleComponent extends BaseComponent {

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public http: HttpClient,
    public webService: WebService,
    public toastr: ToastrService,
    public spinner: NgxSpinnerService,
    public authAppService: AuthService,
    public appService: AppService,
    public location: Location
  ) {
    super(
      router,
      route,
      authAppService,
      appService,
      http,
      webService,
      toastr,
      spinner,
      location
    );
  }

  loadGoogleScript() {
    this.loadExternalScript(
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyDgJmdJ8zIRjCJL8eWGsy0FIItTgulrLK0&libraries=places&signed_in=true"
    ).then(() => {
      this.initGoogleSearchBox();
    });
  }

  initGoogleSearchBox() {
    var centerSfo = new google.maps.LatLng(this.lat, this.lng);
    var circle = new google.maps.Circle({ radius: 1000, center: centerSfo });
    var options = {};
    if (this.lat) {
      options = {
        bounds: circle.getBounds(),
        strictBounds: true
      }
    } else {
      options = {
        strictBounds: false
      }
    }
    const input = document.getElementById("searchLocationInput");
    const searchBox = new google.maps.places.Autocomplete(input, options);
    searchBox.addListener("place_changed", () => {
      this.handleGoogleSearchResult(searchBox);
    });

    const inputGoogle = document.getElementById("searchLocationGoogleInput");
    const searchBoxGoogle = new google.maps.places.Autocomplete(inputGoogle, options);
    searchBoxGoogle.addListener("place_changed", () => {
      this.handleGoogleSearchResult(searchBoxGoogle);
    });
  }

  handleGoogleSearchResult(searchBox){
    const firstPlace = searchBox.getPlace();
    console.log(firstPlace);
    const position = firstPlace.geometry.location;
    this.addressName = firstPlace.name;
    var vicinity = firstPlace.vicinity
    if(vicinity) {
      this.address = vicinity;
    } else {
      this.address = firstPlace.formatted_address;
    }
    this.currentPlaceId = firstPlace.place_id;
    this.lat = position.lat();
    this.lng = position.lng();
    localStorage.setItem("lat", this.lat);
    localStorage.setItem("lng", this.lng);
    localStorage.setItem(Constants.SETTINGS_ADDRESS, this.address);
    localStorage.setItem(Constants.SETTINGS_PLACEID, this.currentPlaceId);
    this.noLocation = false;

    this.appService.Venue = this.addressName;

    if (this.sessionType == 3) {
      this.askLocationModal.hide();
      this.locationModal.hide();
      this.locationGoogleModal.hide();
      this.GetSongRequestByStandard();
      this.GetSpotifyPlaylist();
      this.googlePlaceSelected();
    } else if (this.sessionType == 4) {
      this.askLocationModal.hide();
      this.GetSongRequest();
    } else {
      this.getSession(false);
    }
  }

  abstract googlePlaceSelected(): void;
}